import DateInput from "./DateInput";
import FilterDropdown from "./FilterDropdown";

export type AccountingPeriodMode = "all" | "1m" | "1y" | "custom";

/** The caller owns date semantics and URL state; this control only edits them. */
export default function AccountingPeriodControl({
  mode, from, to, label, error, allowAll = false, customOpen,
  onModeChange, onFromChange, onToChange,
}: {
  mode: AccountingPeriodMode;
  from: string;
  to: string;
  label: string;
  error?: string | null;
  allowAll?: boolean;
  customOpen: boolean;
  onModeChange: (mode: AccountingPeriodMode) => void;
  onFromChange: (value: string) => void;
  onToChange: (value: string) => void;
}) {
  return (
    <section aria-label="Belegzeitraum" className="min-w-0 space-y-2">
      <div className="flex flex-wrap items-center gap-x-3 gap-y-2">
        <FilterDropdown<AccountingPeriodMode>
          label="Zeitraum" ariaLabel="Belegzeitraum wählen" showValue
          value={mode} defaultValue={allowAll ? "all" : "1m"}
          options={[
            ...(allowAll ? [{ value: "all" as const, label: "Alle Belege" }] : []),
            { value: "1m", label: "1 Monat" },
            { value: "1y", label: "1 Jahr" },
            { value: "custom", label: "Eigener Zeitraum" },
          ]}
          onChange={onModeChange}
        />
        {label ? <p className="text-sm text-slate-600" aria-live="polite">{label}</p> : null}
      </div>
      {customOpen ? (
        <div className="flex flex-wrap gap-3">
          <label className="min-w-0 text-xs font-medium text-slate-600">
            <span className="mb-1 block">Von</span>
            <DateInput value={from} onChange={onFromChange} ariaLabel="Belegzeitraum von wählen" placeholder="Von" />
          </label>
          <label className="min-w-0 text-xs font-medium text-slate-600">
            <span className="mb-1 block">Bis</span>
            <DateInput value={to} onChange={onToChange} ariaLabel="Belegzeitraum bis wählen" placeholder="Bis" />
          </label>
        </div>
      ) : null}
      {error ? <p role="alert" className="text-sm text-rose-700">{error}</p> : null}
    </section>
  );
}
